// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_3s-0";
export var eligibilityCardNotEligible = "_3s-1";